import React from 'react';

/** A glowing portal: more worlds on the way. */
export default function PortalIcon({ size = 24, color = 'currentColor', className = '' }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" className={className} aria-hidden="true">
      {/* Arch frame, blocky */}
      <path d="M5 21V9.5a7 7 0 0 1 14 0V21" stroke={color} strokeWidth="1.5" strokeLinecap="round" />
      <path d="M7.5 21V10a4.5 4.5 0 0 1 9 0v11H7.5Z" fill={color} opacity="0.2" />
      {/* Swirl inside */}
      <path d="M12 16.5c-1.8 0-2.6-1.4-2.2-2.7.5-1.4 2.3-1.8 3.3-.8.8.8.4 2-.5 2-.7 0-.9-.8-.4-1.1"
            stroke={color} strokeWidth="1.3" strokeLinecap="round" />
      <path d="M3 21h18" stroke={color} strokeWidth="1.5" strokeLinecap="round" />
      {/* Sparkles escaping */}
      <path d="M20.2 3l.5 1.2 1.2.5-1.2.5-.5 1.2-.5-1.2-1.2-.5 1.2-.5z" fill={color} opacity="0.8" />
      <path d="M3.6 4.5l.4.9.9.4-.9.4-.4.9-.4-.9-.9-.4.9-.4z" fill={color} opacity="0.55" />
    </svg>
  );
}
